var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.promotion)?_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v(_vm._s(_vm.promotion.name))]),_c('div',{staticClass:"promo-detail__text"},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.promotion.detail)}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }